import { savePushSubscription } from "./notification_helper";

const keyToUint8Array = (value) => {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const data = atob((value + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...data].map((character) => character.charCodeAt(0)));
};

const subscriptionPayload = (subscription) => ({
  endpoint: subscription.endpoint,
  p256dh: subscription.getKey("p256dh")
    ? btoa(
        String.fromCharCode(...new Uint8Array(subscription.getKey("p256dh")))
      )
    : "",
  auth: subscription.getKey("auth")
    ? btoa(String.fromCharCode(...new Uint8Array(subscription.getKey("auth"))))
    : "",
});

export const registerDesktopPushSubscription = async () => {
  if (typeof window === "undefined" || !("Notification" in window))
    return {
      registered: false,
      reason: "This browser does not support desktop notifications.",
    };
  if (Notification.permission !== "granted")
    return {
      registered: false,
      reason: "Browser permission has not been granted.",
    };
  if (!("serviceWorker" in navigator) || !window.isSecureContext)
    return {
      registered: false,
      reason: "Desktop notifications require HTTPS or a localhost connection.",
    };
  if (localStorage.getItem("piers.desktopNotificationsDisabled") === "true")
    return {
      registered: false,
      reason: "Desktop notifications are disabled for this browser.",
    };

  const vapid = process.env.REACT_APP_VAPID_PUBLIC_KEY;
  if (!vapid)
    return {
      registered: false,
      reason:
        "Desktop notifications have not been configured for this environment.",
    };

  const registration = await navigator.serviceWorker.register(
    "/notification-sw.js"
  );
  const subscription =
    (await registration.pushManager.getSubscription()) ||
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: keyToUint8Array(vapid),
    }));
  const response = await savePushSubscription(
    subscriptionPayload(subscription)
  );
  if (!response?.status) throw new Error("Subscription could not be saved.");
  return { registered: true };
};
